import styled, { css } from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import TextStyles, {
  FontFamilySmartScreen,
} from "../../../components/shared/typography.styles"
import VariantContainer from "../../atoms/variant-container"

export const FeatureCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--dark-mode-body-grey);
  text-align: center;

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
  }
`

const TabletHeadingStyle = css`
  ${FontFamilySmartScreen}
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
  /* or 25px */

  letter-spacing: 0.08em;
  text-transform: uppercase;
`

export const FeatureTitle = styled.h3`
  ${TextStyles.mobileTextStyles.MobileHeadingTwoSemiBold}
  display: inline-block;
  margin-top: 24px;
  @media (min-width: ${Breakpoints.md}) {
    ${TabletHeadingStyle}
    margin-top: 0px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${TextStyles.desktopTextStyles.HeadingTwoRegular}
    font-size: 24px;
    font-weight: 300;
    /*white-space: nowrap;*/
  }
`

export const FeatureText = styled.p`
  ${TextStyles.mobileTextStyles.MobileBodyRegular}
  margin-top: 24px;
  @media (min-width: ${Breakpoints.md}) {
    ${TextStyles.tabletTextStyles.TabletBodyRegular}
    margin-top: 16px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${TextStyles.desktopTextStyles.BodyText18}
    margin-top: 24px;
  }
`
